import { render, staticRenderFns } from "./ServiceCompanyDetailPage.vue?vue&type=template&id=5bf0c034&scoped=true"
import script from "./ServiceCompanyDetailPage.vue?vue&type=script&lang=js"
export * from "./ServiceCompanyDetailPage.vue?vue&type=script&lang=js"
import style0 from "./ServiceCompanyDetailPage.vue?vue&type=style&index=0&id=5bf0c034&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf0c034",
  null
  
)

export default component.exports